/* Fuzance · Lecteur Fuzance FM : bouton lecture / pause, équaliseur animé pendant l'écoute.
   Élément personnalisé <fz-fm> : il survit au rechargement de la section dans l'éditeur de thème.
   Playlist : si l'élément <audio> porte data-tracks (liens séparés par |), les morceaux s'enchaînent en boucle.
   Amélioration progressive : sans JavaScript, le bouton n'est pas actif (le lecteur reste décoratif). */
(function () {
  'use strict';
  if (customElements.get('fz-fm')) return;

  function FzFm() { return Reflect.construct(HTMLElement, [], FzFm); }
  FzFm.prototype = Object.create(HTMLElement.prototype);
  FzFm.prototype.constructor = FzFm;
  Object.setPrototypeOf(FzFm, HTMLElement);

  FzFm.prototype.connectedCallback = function () {
    var self = this;
    if (this._ready) return;
    this._ready = true;
    this.btn = this.querySelector('[data-fz-fm-toggle]');
    this.audio = this.querySelector('[data-fz-fm-audio]');
    this.status = this.querySelector('[data-fz-fm-status]');
    if (!this.btn || !this.audio) return;
    this.tracks = (this.audio.getAttribute('data-tracks') || '').split('|').filter(Boolean);
    this.idx = 0;

    this._onToggle = function () {
      if (self.audio.paused) {
        /* une seule radio à la fois sur la page */
        Array.prototype.forEach.call(document.querySelectorAll('fz-fm'), function (o) { if (o !== self && o.pause) o.pause(); });
        self.playNow();
      } else {
        self.audio.pause();
      }
    };
    this._onPlay = function () { self.setPlaying(true); };
    this._onPause = function () { if (!self._switching) self.setPlaying(false); };
    this._onEnded = function () {
      if (self.tracks.length > 1) { self.next(); } else { self.setPlaying(false); }
    };
    this._onError = function () {
      /* morceau illisible : on passe au suivant (une fois par morceau), sinon on s'arrête */
      if (self.tracks.length > 1 && !self._skipped) { self._skipped = true; self.next(); return; }
      self.setPlaying(false); self.say('Ce morceau ne peut pas être lu pour le moment.');
    };
    this.btn.addEventListener('click', this._onToggle);
    this.audio.addEventListener('play', this._onPlay);
    this.audio.addEventListener('pause', this._onPause);
    this.audio.addEventListener('ended', this._onEnded);
    this.audio.addEventListener('error', this._onError);
  };

  FzFm.prototype.playNow = function () {
    var self = this, p = this.audio.play();
    if (p && p.catch) p.catch(function () { self.say('Impossible de lancer la lecture pour le moment.'); self.setPlaying(false); });
  };

  FzFm.prototype.next = function () {
    this.idx = (this.idx + 1) % this.tracks.length;
    this._switching = true;
    this.audio.src = this.tracks[this.idx];
    this._switching = false;
    this.playNow();
    var self = this; this.audio.addEventListener('playing', function once() { self._skipped = false; self.audio.removeEventListener('playing', once); });
  };

  FzFm.prototype.say = function (txt) { if (this.status) this.status.textContent = txt; };

  FzFm.prototype.setPlaying = function (on) {
    this.classList.toggle('is-playing', on);
    if (!this.btn) return;
    this.btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    this.btn.setAttribute('aria-label', on ? this.btn.getAttribute('data-label-pause') : this.btn.getAttribute('data-label-play'));
    this.say(on ? 'Lecture en cours.' : 'Lecture en pause.');
  };

  FzFm.prototype.pause = function () { if (this.audio && !this.audio.paused) this.audio.pause(); };

  FzFm.prototype.disconnectedCallback = function () {
    if (this.audio) { this.audio.pause(); this.audio.removeEventListener('play', this._onPlay); this.audio.removeEventListener('pause', this._onPause); this.audio.removeEventListener('ended', this._onEnded); this.audio.removeEventListener('error', this._onError); }
    if (this.btn) this.btn.removeEventListener('click', this._onToggle);
    this._ready = false;
  };

  customElements.define('fz-fm', FzFm);
})();
